import Privacy from "../assets/privacy.svg";
import { useAppContext } from "../hooks/useAppContext";
import { getTranslation } from "../locales/getTranslation";

const ModalPrivacy = () => {
  const { locale } = useAppContext();
  return (
    <div className="flex flex-col items-center justify-center gap-5 rounded-2xl bg-grayscale-solid-elevate-level1 px-8 py-10 shadow">
      <img className="h-[70px] w-[70px]" src={Privacy} alt="" />
      <h1 className="text-center text-sm font-bold leading-tight text-grayscale-solid-g10 sm:text-base">
        {getTranslation(locale, "Privacy Notice")}
      </h1>
      <ul className="flex flex-col gap-2">
        <li
          className={`list-disc text-[10px] font-normal leading-[20px] text-grayscale-solid-g10 sm:text-[14px]`}
        >
          {getTranslation(locale, "Privacy Policy #1")}
        </li>
        <li
          className={`list-disc text-[10px] font-normal leading-[20px] text-grayscale-solid-g10 sm:text-[14px]`}
        >
          {getTranslation(locale, "Privacy Policy #2")}
        </li>
      </ul>
    </div>
  );
};

export default ModalPrivacy;
